import React from 'react';
import { Log, OidcClient } from 'oidc-client';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';

import { CircularProgress } from '@material-ui/core';

import { exchangeCode } from '../../modules/Auth';

import config from '../../core/config';

import {
  LoadingContainer,
} from './styles.js';

class OIDC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidRequest: false,
    };
  }

  async componentDidMount() {
    const {
      cookies,
      exchangeCode,
    } = this.props;

    Log.logger = console;
    Log.level = Log.INFO;

    const oidcClient = new OidcClient({
      authority: `${config.sso.url}/api/oidc`,
      client_id: config.sso.clientId,
      loadUserInfo: false,
      redirect_uri: config.sso.redirectUri,
      silent_redirect_uri: config.sso.redirectUri,
      response_type: 'code',
      response_mode: 'query',
      scope: 'openid email profile offline_access',
      prompt: 'consent',
      post_logout_redirect_uri: config.base_href,
    });

    let response, state;
    try {
      ({ response, state } = await oidcClient.readSigninResponseState());
    } catch(e) {
      this.setState({ invalidRequest: true });
      return;
    }

    if (response.code) {
      try {
        await exchangeCode(response.code, state._code_verifier, cookies);
      } catch(e) {
      }
    } else {
      this.setState({ invalidRequest: true });
    }
  }

  render() {
    const { invalidRequest } = this.state;

    const {
      auth: {
        authError,
      },
    } = this.props;

    return (
      <LoadingContainer>
      { authError ? (
        <div>An error occurred trying to log you in. Please try again. {authError}</div>
      ) : invalidRequest ? (
        <div>Request invalid. Please try again.</div>
      ) : (
        <CircularProgress size={70} style={{ color: '#caa854' }} />
      )}
      </LoadingContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.authState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      exchangeCode: exchangeCode,
    },
    dispatch,
  );
}

OIDC.propTypes = {
  exchangeCode: PropTypes.func,
};

export default compose(
  withRouter,
  withCookies,
  connect(mapStateToProps, mapDispatchToProps),
)(OIDC);
